'use strict';

import React from 'react';
import flux from 'utils/flux';
import { Link } from 'react-router';
import Immutable from 'immutable';
import queryString from 'query-string';
import dom from 'utils/dom';
import api from 'utils/api';
import classnames from 'classnames';
import Thumb from 'components/thumb';
import prettyBytes from 'pretty-bytes';
import QuotaWarning from 'components/quota/quotaWarning';
import store from 'store';

var InstantDownloadModal = React.createClass({

    displayName: 'InstantDownloadModal',

    propTypes: {
        media: React.PropTypes.object
    },

    toggleCheck( fileId, e ) {
        e.preventDefault();
        flux.getActions('modals').toggleDownload(fileId);
    },

    handleDownload(e) {
        e.preventDefault();
        flux.getActions('modals').generateDownload();
    },

    handleOnSubmit(e) {
        e.preventDefault();
        const asset = this.props.media.toJS();
        let params = {};

        asset.files.forEach( file => {
            if ( !file._selected ) {
                return;
            }

            if ( !params[ asset.id ] ) {
                params[ asset.id ] = file.key;
            }
            else {
                params[ asset.id ] += `,${file.key}`;
            }
        });

        flux.getStore('media').checkQuota( params ).then( response => {
            const { quotaExceeded } = flux.getStore('media').getState();

            if ( quotaExceeded ) {
                return false;
            }

            this.refs.download.getDOMNode().submit();

            asset.requires_watermark && flux.getActions('modals').openWatermarkModal( Immutable.List([ asset ]) );
        });
    },

    render() {
        if ( !this.props.media ) {
            return false;
        }

        var item = this.props.media.toJS();
        var itemTitle = (item.title && item.title.length) ? item.title : item.name;
        var master = item.files[0];
        var mediaboxToken = store.get('mediabox_token');

        var totalSelected = flux.getStore('modals').getSelectedInstantDownloadItems();
        const { quotaExceeded } = this.props;

        return(
            <div>
                <h4>{flux.t('instant_download')}</h4>
                <div className="instantdownload__item">
                    <form ref="download" onSubmit={this.handleOnSubmit} action={window.config.baseUrl + '/download'}>
                    <input type="hidden" name="token" value={mediaboxToken} />
                        <div className="item__image">
                            <Thumb className="item__preview" media={this.props.media} onClickOpenModal={false} />
                        </div>

                        <div className="item__description">
                            <div className="description__download">
                                <table>
                                    <thead>
                                        <th className="item__title">{itemTitle}</th>
                                        <th>{flux.t('download_file_mimetype')}</th>
                                        <th>{flux.t('download_file_size')}</th>
                                    </thead>
                                    <tbody>
                                        {item.files.map( (file) => {
                                            return (
                                                <tr key={'i-' + item.id + '-' + file.key}>
                                                    <td className="download__body--checkbox">
                                                        <div className="field__checkbox download__checkbox">
                                                            <input checked={file._selected} name={item.id} value={file.key} type="checkbox" readOnly />
                                                            <label onClick={this.toggleCheck.bind(null, file.key)} htmlFor="check__all">{file.name}</label>
                                                        </div>
                                                    </td>
                                                    <td>{file.mimeType}</td>
                                                    <td>{prettyBytes(file.size)}</td>
                                                </tr>);
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="instantdownload__footer">
                            <QuotaWarning />
                            <button type="submit" disabled={totalSelected.length === 0 || quotaExceeded} className="btn btn-border selection__download submit__instantdownload">
                                <i className="gopro-download" />
                                {flux.t('download')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
});

module.exports = InstantDownloadModal;



// WEBPACK FOOTER //
// ./app/components/modals/instantDownloadModal.jsx